// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"BuildingView_Wrapper__3JD-H","TextImage":"BuildingView_TextImage__6u6Ho","PageImage":"BuildingView_PageImage__3j9mw"};